<template>
    <div class="submenu_holder">

        <ul class="submenu items">
            <li class="item" v-if="getUserType > 1">
            <router-link :to="{ name: 'evalvationProgramList' }">
                <span class="item_text">Seznam programov</span>
            </router-link>
            </li>

            <li class="item">
            <router-link :to="{ name: 'evalvationPrograms' }">
                <span class="item_text">Programi</span>
            </router-link>
            </li>

            <li class="item">
            <router-link :to="{ name: 'evalvationDashboard' }">
                <span class="item_text">Prikaz podatkov</span>
            </router-link>
            </li>

            <li class="item" v-if="(dashboard_data_by_program.length > 0 && getUserType == 2) || isPermissionToInternal">
            <router-link :to="{ name: 'questionnaireBuild' }">
                <span class="item_text">Obrazec</span>
            </router-link>
            </li>

            <!-- Uncomment if needed -->
            <!--
            <li class="item" v-if="getUserType > 1 || isPermissionToInternal">
            <router-link :to="{ name: 'questionnaireBuildDoc' }">
                <span class="item_text">Obrazec (doktorski)</span>
            </router-link>
            </li>
            -->

            <li class="item" v-if="is_department_data">
            <router-link :to="{ name: 'evalvationDepartments' }">
                <span class="item_text">Oddelki</span>
            </router-link>
            </li>

            <li class="item" v-if="is_department_data && (getUserType == 1 || getUserType == 2)">
            <router-link :to="{ name: 'departmentsQuestionnaire' }">
                <span class="item_text">Obrazec za oddelke</span>
            </router-link>
            </li>

            <li class="item" v-if="getUserType > 1">
            <router-link :to="{ name: 'evalvationAnalytics' }">
                <span class="item_text">Analitika</span>
            </router-link>
            </li>

            <li class="item" v-if="getUserType > 1">
            <router-link :to="{ name: 'evalvationAI' }">
                <span class="item_text">SEP AI</span>
            </router-link>
            </li>

            <li class="item">
            <router-link :to="{ name: 'FAQEvalvation' }">
                Pogosto zastavljena vprašanja
            </router-link>
            </li>
        </ul>

        <div v-show="showyear" class="change_year">
            Študijsko leto: 
            <select @change="changeYear(selected_year)" v-model="selected_year">
                <option 
                    v-for="year in getYears" 
                    v-bind:value="year" 
                    v-bind:key="year" 
                    :selected="(year == selected_year ? true : null)"
                >
                    {{ year }}
                </option>
            </select>
        </div>
    </div>
</template>


<script>
	import { mapActions } from 'vuex';
	
	export default {
        name: 'EvalvationSubMenu',
        props: {
            showyear: {
                type: Boolean,
                default: true
            }
        },
		data: function() {
			return {
                selected_year: this.$store.getters.year
			}
		},
		computed: {
            getYear(){
				return this.$store.getters.year;
            },
            // Get loged user faculty id
            getFacultyId() {
                return this.$store.getters.getFaculty.id;
            },
            // Get loged user type
			getUserType(){
				return this.$store.state.user.type;
            },
            // Get all years
			getYears() {
				return this.$store.getters.getYears;
            },
            isPermissionToInternal(){
                return this.getUserType == 1 && this.getFacultyInternalPermission.includes(this.$store.getters.getFaculty.id);
            },
            //Get array of faculties that have permission to internal questionnaire
            getFacultyInternalPermission(){
                return this.$store.getters.faculties_internal_permission;
            },

            dashboard_data_by_program() {
                return Object.values(this.$store.getters.evalvation_programs_all);
            },

            //check if there is department data for this faculty
            is_department_data() {
                //admin could have all departments from all faculties fetched in users list
                if(this.getUserType > 1){
                    for(let department of Object.values(this.$store.getters.evalvation_departments)){
                        if(department.faculty_id == this.getFacultyId)
                            return true
                    }
                    return false;
                }

                return Object.keys(this.$store.getters.evalvation_departments).length > 0;
            },
		},
		methods: { 		
            ...mapActions([
                'changeYear',
                'getDepartmentsListForFaculty',
                'getDepartmentsListForUser',
                'getProgramsListAll'
            ]),
        },
		created(){
            if(!this.is_department_data) {
                if (this.getUserType > 0) this.getDepartmentsListForFaculty();
                else this.getDepartmentsListForUser();
            }

            if(this.getUserType > 1 && this.dashboard_data_by_program.length == 0) {
                this.getProgramsListAll();
            }
		}
	}
</script>


<style lang="scss" scoped>
</style>
